// src/components/routes/Afirst/Afirst.js

import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Afirst.css";
import Header from "../Other/Header/Header";
import BackButton from "../Other/BackButton/BackButton";
import ZForm from "../Forms/Zform";
import CallsInProgressPanel from "../Dashboard/CallsInProgressPanel";

const PUBLIC_AUTH_PATH_PATTERNS = [
    /^\/login$/,
    /^\/register$/,
    /^\/logout$/,
    /^\/forgot-password$/,
    /^\/reset-password\//,
    /^\/approve-user\//
];

const isPublicAuthPath = (pathname) => PUBLIC_AUTH_PATH_PATTERNS.some((pattern) => pattern.test(pathname));

const getBusinessCenterId = () => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) return '';

    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const tokenData = JSON.parse(window.atob(base64));
        const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
        const userData = { ...storedUser, ...tokenData };
        return userData.business_center_id || '';
    } catch (error) {
        return '';
    }
};

const Afirst = () => {
    const location = useLocation();
    const [businessCenterId, setBusinessCenterId] = useState(getBusinessCenterId());

    useEffect(() => {
        setBusinessCenterId(getBusinessCenterId());
    }, [location]);

    return (
        <div className="everything">
            <div className="main-first">
                <Header />
                <div className="app-nav-back-button-wrap">
                    <BackButton />
                </div>
            </div>
            <div className={`main-second ${isPublicAuthPath(location.pathname) ? 'main-second--full' : ''}`}>
                <div className="second-form">
                    <ZForm />
                </div>
            </div>
            {!isPublicAuthPath(location.pathname) && (
                <CallsInProgressPanel businessCenterId={businessCenterId} />
            )}
        </div>
    );
};

export default Afirst;
